import React, { useEffect, useState } from 'react';
import api, { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';

import { Row, Col } from 'react-bootstrap';

import {
  Select,
  Text,
  Button,
  Input,
  Modal,
  Radio
} from 'v3/components'

import {
  fetchDriver,
  fetchVehicle,
  fetchWagons,
  fetchClients,
  fetchBlacklistTypes,
  fetchShippingCompany
} from 'utils/fetches';

import { useNavigate } from 'react-router-dom';

export default function Filter({
  showAdvancedFiltersModal,
  setShowAdvancedFiltersModal,
  setQtdAdvancedFilters,
  queryParams,
  setAdvancedFilters,
  advancedFilters,
  onChange,
  loading
}) {

  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const [blacklistType, setBlacklistType] = useState([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({ search: queryParams.toString() });
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, [advancedFilters]);

  useEffect(() => {
    const isNotEmpty = value =>
      value !== null && value !== undefined && value !== '' && value !== 0;

    const validateAdvancedFilters = {
      driver: advancedFilters?.driver?.length,
      vehicle: advancedFilters?.vehicle?.length,
      wagon: advancedFilters?.wagon?.length,
      clientTaker: advancedFilters?.clientTaker?.length,
      shippingCompany: advancedFilters?.shippingCompany?.length,
      active: String(advancedFilters?.active),
    };

    setQtdAdvancedFilters(
      Object.values(validateAdvancedFilters).filter(isNotEmpty).length
    );
  }, [advancedFilters]);

  async function handleDrivesParams(driversIds) {
    try {
      if (driversIds && driversIds.length > 0) {
        const allDrives = [];
        await Promise.all(
          driversIds.map(async driver => {

            const response = await api.get(`persons/${driver}`)

            if (response.data.id) {
              allDrives.push(response.data);
            }
          })
        );
        setAdvancedFilters(old => ({
          ...old,
          driver: allDrives,
        }));
      }
    } catch (error) {
      snackbar.show(
        <Text weight={500}>
          Não foi possível recuperar todos os filtros de motoristas setados
          na url
        </Text>,
        { type: 'warning' }
      );
    }
  }

  async function handleShippingCompanyParams(shippingCompanyIds) {
    try {
      if (shippingCompanyIds && shippingCompanyIds.length > 0) {
        const allShippingCompany = [];
        await Promise.all(
          shippingCompanyIds.map(async shipping => {

            const response = await api.get(`persons/${shipping}`)

            if (response.data.id) {
              allShippingCompany.push(response.data);
            }
          })
        );
        setAdvancedFilters(old => ({
          ...old,
          shippingCompany: allShippingCompany,
        }));
      }
    } catch (error) {
      snackbar.show(
        <Text weight={500}>
          Não foi possível recuperar todos os filtros de transportadora setados
          na url
        </Text>,
        { type: 'warning' }
      );
    }
  }

  async function handleClientTakerParams(clientTakerIds) {
    try {
      if (clientTakerIds && clientTakerIds.length > 0) {
        const allClientTaker = [];
        await Promise.all(
          clientTakerIds.map(async driver => {

            const response = await api.get(`persons/${driver}`)

            if (response.data.id) {
              allClientTaker.push(response.data);
            }
          })
        );
        setAdvancedFilters(old => ({
          ...old,
          clientTaker: allClientTaker,
        }));
      }
    } catch (error) {
      snackbar.show(
        <Text weight={500}>
          Não foi possível recuperar todos os filtros de clientes setados
          na url
        </Text>,
        { type: 'warning' }
      );
    }
  }

  async function handleVehiclesParams(vehiclesIds) {
    try {
      if (vehiclesIds && vehiclesIds.length > 0) {

        const response = await cooperplaceApi.get(`vehicles/select-by-ids`, {
          params: {
            vehicleIds: vehiclesIds
          }
        })

        setAdvancedFilters(old => ({
          ...old,
          vehicle: response.data || [],
        }));
      }
    } catch (error) {
      snackbar.show(
        <Text weight={500}>
          Não foi possível recuperar todos os filtros de veiculos setados
          na url
        </Text>,
        { type: 'warning' }
      );
    }
  }

  async function handleWagonsParams(wagonsIds) {
    try {
      if (wagonsIds && wagonsIds.length > 0) {

        const response = await cooperplaceApi.get(`wagons/select-by-ids`, {
          params: {
            wagonIds: wagonsIds
          }
        })

        setAdvancedFilters(old => ({
          ...old,
          wagon: response.data || [],
        }));
      }
    } catch (error) {
      snackbar.show(
        <Text weight={500}>
          Não foi possível recuperar todos os filtros de implementos setados
          na url
        </Text>,
        { type: 'warning' }
      );
    }
  }


  async function handleInitializeParams() {


    if (queryParams.has('vehicleId[]')) {
      const vehiclesIds = queryParams.getAll('vehicleId[]');
      await handleVehiclesParams(vehiclesIds);
    }

    if (queryParams.has('wagonId[]')) {
      const wagonsIds = queryParams.getAll('wagonId[]');
      await handleWagonsParams(wagonsIds);
    }

    if (queryParams.has('driverId[]')) {
      const driversIds = queryParams.getAll('driverId[]');
      await handleDrivesParams(driversIds);
    }

    if (queryParams.has('clientTakerId[]')) {
      const clientTakerIds = queryParams.getAll('clientTakerId[]');
      await handleClientTakerParams(clientTakerIds);
    }

    if (queryParams.has('shippingCompanyId[]')) {
      const shippingCompanyIds = queryParams.getAll('shippingCompanyId[]');
      await handleShippingCompanyParams(shippingCompanyIds);
    }

    if (queryParams.has('active')) {
      setAdvancedFilters(old => ({ ...old, active: queryParams.get('active') }));
    } else {
      setAdvancedFilters(old => ({ ...old, active: -1 }));
      queryParams.set('active', -1);
    }

    if (queryParams.has('reason')) {
      setAdvancedFilters(old => ({ ...old, active: queryParams.get('reason') }));
    }

    if (queryParams.has('blacklistTypeId')) {

      const blacklistTypeId = queryParams.get('blacklistTypeId');
      const types = await fetchBlacklistTypes();

      const type = types.find(blacklistType => blacklistType.id == blacklistTypeId);

      setAdvancedFilters(old => ({ ...old, blacklistType: type }));
    }
  }

  useEffect(() => {
    fetchBlacklistTypes().then(setBlacklistType)
    handleInitializeParams();
  }, []);

  const handlerAdvancedFilters = () => {
    onChange()
    setShowAdvancedFiltersModal(false);
  }

  return (
    <>
      <Modal
        heading={
          <Text color="dark" type="header">
            Filtro Avançado
          </Text>
        }
        show={showAdvancedFiltersModal}
        handleClose={() => { setShowAdvancedFiltersModal(false) }}
        body={
          <Row>
            <Col md={4} xs={12} className="mb-3">
              <Select.Async
                modalHeading="Selecione um motorista"
                modalBodyTitle="Motoristas:"
                label="Motorista"
                onSearch={fetchDriver}
                value={advancedFilters?.driver}
                onChange={value => {
                  if (Array.isArray(value)) {
                    queryParams.delete('driverId[]');
                    value
                      .map(driver => driver.id)
                      .forEach(processed => {
                        queryParams.append('driverId[]', processed);
                      })
                  } else {
                    queryParams.delete('driverId[]')
                  }
                  setAdvancedFilters(old => ({ ...old, driver: value }));
                }}
                horizontal
                multiple
                getOptionLabel={option => `${option.social_name} - ${option.cgccpf}`}
                getOptionValue={option => option.id}
              />
            </Col>
            <Col md={4} xs={12} className="mb-3">
              <Select.Async
                modalHeading="Selecione um veiculo"
                modalBodyTitle="Veiculos:"
                label="Veiculo"
                onSearch={fetchVehicle}
                value={advancedFilters?.vehicle}
                onChange={value => {
                  if (Array.isArray(value)) {
                    queryParams.delete('vehicleId[]');
                    value
                      .map(vehicle => vehicle.id)
                      .forEach(processed => {
                        queryParams.append('vehicleId[]', processed);
                      })
                  } else {
                    queryParams.delete('vehicleId[]')
                  }
                  setAdvancedFilters(old => ({ ...old, vehicle: value }));
                }}
                multiple
                horizontal
                getOptionLabel={option => option.plate}
                getOptionValue={option => option.id}
              />
            </Col>
            <Col md={4} xs={12} className="mb-3">
              <Select.Async
                modalHeading="Selecione um implemento"
                modalBodyTitle="Implementos:"
                label="Implemento"
                onSearch={fetchWagons}
                value={advancedFilters?.wagon}
                onChange={value => {
                  if (Array.isArray(value)) {
                    queryParams.delete('wagonId[]');
                    value
                      .map(wagon => wagon.id)
                      .forEach(processed => {
                        queryParams.append('wagonId[]', processed);
                      })
                  } else {
                    queryParams.delete('wagonId[]')
                  }
                  setAdvancedFilters(old => ({ ...old, wagon: value }));
                }}
                horizontal
                multiple
                getOptionLabel={option => option.plate}
                getOptionValue={option => option.id}
              />
            </Col>
            <Col md={4} xs={12} className="mb-3">
              <Select.Async
                modalHeading="Selecione um cliente"
                modalBodyTitle="Clientes:"
                label="Cliente"
                onSearch={fetchClients}
                value={advancedFilters?.clientTaker}
                onChange={value => {
                  if (Array.isArray(value)) {
                    queryParams.delete('clientTakerId[]');
                    value
                      .map(client => client.id)
                      .forEach(processed => {
                        queryParams.append('clientTakerId[]', processed);
                      })
                  } else {
                    queryParams.delete('clientTakerId[]')
                  }
                  setAdvancedFilters(old => ({ ...old, clientTaker: value }));
                }}
                horizontal
                multiple
                getOptionLabel={option => `${option.social_name} - ${option.cgccpf}`}
                getOptionValue={option => option.id}
              />
            </Col>
            <Col md={4} xs={12} className="mb-3">
              <Select.Async
                modalHeading="Selecione uma transportadora"
                modalBodyTitle="Transportadoras:"
                label="Transportadora"
                onSearch={fetchShippingCompany}
                value={advancedFilters?.shippingCompany}
                onChange={value => {
                  if (Array.isArray(value)) {
                    queryParams.delete('shippingCompanyId[]');
                    value
                      .map(wagon => wagon.id)
                      .forEach(processed => {
                        queryParams.append('shippingCompanyId[]', processed);
                      })
                  } else {
                    queryParams.delete('shippingCompanyId[]')
                  }
                  setAdvancedFilters(old => ({ ...old, shippingCompany: value }));
                }}
                horizontal
                multiple
                getOptionLabel={option => `${option.socialName || option.social_name} - ${option.cpfCnpj || option.cgccpf}`}
                getOptionValue={option => option.id}
              />
            </Col>
            <Col md={6} sm={12}>
              <Radio.Group
                label="Blacklist ativa"
                horizontal
                onChange={({ target: { value: active } }) => {
                  setAdvancedFilters(old => ({ ...old, active }))
                  if (active == -1) {
                    queryParams.set('active', -1);
                  } else if (active == 0) {
                    queryParams.set('active', 0);
                  } else {
                    queryParams.set('active', 1);
                  }
                }}
                value={Number(advancedFilters.active)}
              >
                <Radio value={1}>
                  <Text color="dark" type="label">
                    Sim
                  </Text>
                </Radio>
                <Radio value={0}>
                  <Text color="dark" type="label">
                    Não
                  </Text>
                </Radio>
                <Radio value={-1}>
                  <Text color="dark" type="label">
                    Todos
                  </Text>
                </Radio>
              </Radio.Group>
            </Col>
          </Row>
        }
        footer={
          <Row>
            <Col>
              <Button
                size="sm"
                onClick={() => handlerAdvancedFilters()}
                disabled={loading}
              >
                <Text weight={500}>Filtrar</Text>
              </Button>
            </Col>
          </Row>
        }
      />

      <Row className="align-items-end">
        <Col md={3} xs={12} className="mb-3">
          <Select
            label="Tipos de blacklist"
            labelTextColor="#fff"
            options={blacklistType}
            value={advancedFilters?.blacklistType}
            getOptionLabel={option => option?.name}
            getOptionValue={option => option?.id}
            onChange={event => {
              setAdvancedFilters(old => ({ ...old, blacklistType: event }));
              if (event === null || event == '') {
                queryParams.delete('blacklistTypeId');
              } else {
                queryParams.set('blacklistTypeId', event.id);
              }
            }}
          />
        </Col>

        <Col md={8} xs={12} className="mb-3 ml-3">
          <Input
            label="Motivo"
            labelColor="#fff"
            value={advancedFilters?.reason}
            onChange={event => {
              setAdvancedFilters(old => ({ ...old, reason: event.target.value }))
              if (event.target.value == '' || event.target.value == null) {
                queryParams.delete('reason');
              } else {
                queryParams.set('reason', event.target.value);
              }
            }}
          />
        </Col>

        <Col md={1} xs={12} className="d-flex align-items-end justify-content-end mb-3 ps-2">
          <Button
            variant="primary"
            onClick={() => onChange()}
            loading={loading}
            height="fit-content"
            disabled={loading}
          >
            <Text type="regular" weight="500">
              Filtrar
            </Text>
          </Button>
        </Col>
      </Row>
    </>
  );
}
